export class ScaleEle {
  constructor(config) {
    //默认配置参数
    this.config = {
      select: '',
      width: null,
      height: null,
      mode: 'contain',
      position: 'center'
    };
    //配置参数合并
    this.config = Object.assign({}, this.config, config);

    this.getScale();
    this.setTrans();
    //响应屏幕变化

  }
  //获取缩放值
  getScale() {
    let obj = this.config;
    let eleWidth = obj.width;
    let eleHeight = obj.height;
    let winWidth = window.innerWidth;
    let winHeight = window.innerHeight;
    if (obj.mode == 'cover') {
      this.eleScale = Math.max(winHeight / eleHeight, winWidth / eleWidth);
    }
    else if (obj.mode == 'contain') {
      this.eleScale = Math.min(winHeight / eleHeight, winWidth / eleWidth);
    }
  }
  //设置元素变换
  setTrans() {
    let config = this.config;
    let dom =document.querySelector(config.select);
    
    css(dom, {
      '-webkit-transform-origin': config.position,
      'transform-origin': config.position,
      '-webkit-transform': 'scale(' + this.eleScale + ')',
      'transform': 'scale(' + this.eleScale + ')'
    });
  }
}
;

function css(dom, obj) {
  Object.keys(obj).forEach(key => {
    dom.style[key] = obj[key];
  })
}